var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8905 15.5781C6.94276 15.5781 3.43211 17.5344 1.19704 20.5703C0.715997 21.2237 0.475474 21.5504 0.483341 21.9919C0.48942 22.3331 0.698135 22.7634 0.959655 22.974C1.29815 23.2467 1.76723 23.2467 2.7054 23.2467H19.0755C20.0137 23.2467 20.4828 23.2467 20.8213 22.974C21.0828 22.7634 21.2915 22.3331 21.2976 21.9919C21.3054 21.5504 21.0649 21.2237 20.5839 20.5703C18.3488 17.5344 14.8382 15.5781 10.8905 15.5781Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4381 13.3873C15.0683 13.3873 18.0112 10.4444 18.0112 6.81424C18.0112 3.18406 15.0683 0.241211 11.4381 0.241211C7.80796 0.241211 4.86511 3.18406 4.86511 6.81424C4.86511 10.4444 7.80796 13.3873 11.4381 13.3873Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b1e9669a.svg";
export { ForwardRef as ReactComponent };